export enum CustomTagType {
  CUSTOM_FIELD_SCOPE,
  CUSTOM_FIELD_DATA_TYPE,
  SOURCE_TYPE,
  PAYMENT_STATUS,
  CUSTOM_COST_TYPE,
  USER_TYPE,
  PROJECT_STATUS_CATEGORY,
}
